import './App.css'

import { useEffect } from 'react'

import Login from './components/Login'
import Mapa from './components/Mapa'
import Menu from './components/Menu'

import { useLogin } from './providers/Login'

const App = () => {

	const { login } = useLogin()

	return (
		<>
			{!login.token && <Login />}
			{!!login.token &&
				<>
					<Menu />
					<Mapa />
				</>
			}
		</>
	);
}

export default App